import { TypeInteractionResult } from "domain/entities/type-interaction";
import { TypeInteractionRepository } from "domain/repositories";

export default class GetAllUseCase {
    private typeInteractionRepository: TypeInteractionRepository;
    
    public constructor(typeInteractionRepository: TypeInteractionRepository) {
        this.typeInteractionRepository = typeInteractionRepository
    }

    public async getAllTypeInteraction(token: Promise<[string | null, string | null]>): Promise<[TypeInteractionResult[], null] | [null, Error]> {
        const [t, ] = await token;
        if (t !== null) {
            return this.typeInteractionRepository.getAllTypeInteraction(t);
        } else {
            return [null, new Error("Autenticación faltante")];
        }
    }
}